var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"},attrs:{"aria-label":_vm.text,"data-balloon-length":"xlarge","data-balloon-pos":"down-right"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }